import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { TermsPage } from './pages/TermsPage';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { initAnalytics } from './utils/analytics';
import { useExchangeRates } from './hooks/useExchangeRates';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
export function App() {
  // Fetch and subscribe to exchange rates from Supabase
  const {
    isLoading,
    error,
    lastUpdated
  } = useExchangeRates();
  useEffect(() => {
    // Initialize Mixpanel when app loads
    initAnalytics();
  }, []);
  // Optional: Show loading or error states
  if (error) {
    console.warn('Using default rates due to error:', error);
  }
  // Simple routing based on pathname
  const path = window.location.pathname;
  return <AuthProvider data-id="element-0">
      <LanguageProvider data-id="element-1">
        {path === '/terms' ? <TermsPage data-id="element-2" /> : path === '/login' ? <LoginPage data-id="element-3" /> : path === '/dashboard' ? <DashboardPage data-id="element-4" /> : <LandingPage data-id="element-5" />}
      </LanguageProvider>
    </AuthProvider>;
}